import request from '@/utils/request'

//查詢
export function SelectBranchBillOfLading (data) {
  return request({
    url: '/billOfLading/SelectBranchBillOfLading',
    method: 'post',
    data: data
  })
}
//获取详情
export function GetDeatils (data) {
  return request({
    url: '/billOfLading/GetDeatils',
    method: 'post',
    data: data
  })
}

//获取详情
export function GetAirfreightQuery (data) {
  return request({
    url: '/billOfLading/GetAirfreightQuery',
    method: 'post',
    data: data
  })
}
export function GetTgInvpo (data) {
  return request({
    url: '/billOfLading/GetTgInvpo',
    method: 'post',
    data: data
  })
}
export function GetDeatilsList (data) {
  return request({
    url: '/billOfLading/GetDeatilsList',
    method: 'post',
    data: data
  })
}

export function GetcontainerList (data) {
  return request({
    url: '/billOfLading/GetcontainerList',
    method: 'post',
    data: data
  })
}
export function GetFile (data) {
  return request({
    url: '/billOfLading/GetFile',
    method: 'get',
    params: data
    // ,
    // responseType: "blob"
    // ,
    // responseType: 'blob'
  })
}

export function GetUrl (data) {
  return request({
    url: '/billOfLading/GetUrl',
    method: 'get',
    params: data
    // ,
    // responseType: "blob"
    // ,
    // responseType: 'blob'
  })
}